module.exports = flarum.core.compat['components/Alert'];